import { render } from "./courses.vue?vue&type=template&id=992f3d4c&scoped=true"
import script from "./courses.vue?vue&type=script&lang=js"
export * from "./courses.vue?vue&type=script&lang=js"

import "./courses.vue?vue&type=style&index=0&id=992f3d4c&lang=scss"
import "./courses.vue?vue&type=style&index=1&id=992f3d4c&lang=scss&scoped=true"
/* custom blocks */
import block0 from "./courses.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-992f3d4c"]])

export default __exports__